export enum Brand {
    AUDI = 'audi',
    SEAT = 'seat',
    SKODA = 'skoda',
    VW = 'vw',
    VWCV = 'vwcv',
    DF = 'df',
}
